export const createWorkspaceProfileRoutes = (basePath: string) =>
  ({
    index: basePath,
  }) as const;
